export default __webpack_public_path__ + "static/media/clairefontaine17.532519a7.jpg";